import { useState } from "react";
import { callAPIForQuery } from "../../../utilities/service";
import { cloneDeep } from "lodash";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const TenantView = () => {
    const navigate = useNavigate();

    const [tenants, setTenants] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const [input, setInput] = useState({
        from_date: moment().format('YYYY-MM-DD'), //'2025-03-08',
        to_date: moment().format('YYYY-MM-DD')
    })
    const updateInputInfo = (key: string, value: string) => {
        const inputCopy: any = cloneDeep(input);
        inputCopy[key] = value;
        setInput(inputCopy);
    }

    const fetchTenants = async () => {
        try {
            const response = await callAPIForQuery({ input: JSON.stringify({ from_date: input.from_date, to_date: input.to_date }), type: "get_tenant" }, "post")
            setTenants(response[0]);
            setLoading(false);
        } catch (err) {
            setError("Failed to load tenants");
            setLoading(false);
        }
    };

    if (loading) return <p>Loading tenants...</p>;
    if (error) return <p className="text-danger">{error}</p>;

    return (
        <>  <div className="row">
            <div className="col-lg-2">
                <div className="form-option">
                    <div className="field-title">From Date</div>
                    <input type="date" className="form-control" value={input.from_date || ''} onChange={(event: any) => {
                        updateInputInfo("from_date", event.target.value)
                    }} />
                </div>
            </div>
            <div className="col-lg-2">
                <div className="form-option">
                    <div className="field-title">To Date</div>
                    <input type="date" className="form-control" value={input.to_date || ''} onChange={(event: any) => {
                        updateInputInfo("to_date", event.target.value)
                    }} />
                </div>
            </div>
            <div className="col-lg-2">
                <div className="form-option">
                    <div className="field-title hide">To Date</div>
                    <input type="button" value="Search" onClick={fetchTenants} />
                </div>
            </div>

        </div>
            <div className="appointment-grid">
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Phone Number</th>
                            <th>Contact Person</th>
                            <th>Contact Phone</th>
                            <th>Address</th>
                            <th>Pincode</th>
                            <th>Email</th>
                            <th>Active</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tenants?.length > 0 ? tenants.map((tenant: any) => (
                            <tr key={tenant.id}>
                                <td>{tenant.id}</td>
                                <td>{tenant.name}</td>
                                <td>{tenant.phone_number}</td>
                                <td>{tenant.contact_person_name}</td>
                                <td>{tenant.contact_person_phone_number}</td>
                                <td>{tenant.address}</td>
                                <td>{tenant.pincode}</td>
                                <td>{tenant.emailid}</td>
                                <td>{tenant.isactive ? "Yes" : "No"}</td>
                                <td><span className="action-link" onClick={() => {
                                    navigate(`/tenant-create?id=${tenant.id}`)
                                }}>View</span></td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan={10} className="text-center">No Tenants found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div></>

    );
};

export default TenantView;
